if (document.querySelector('#calendar-iframe')) {
  document.querySelectorAll('.user-input').forEach((input) => {
    input.addEventListener('click', event => {
      document.querySelector('#calendar-iframe').src = input.value;
    });
  });
  if (document.querySelector('#my-user')) {
    window.addEventListener('message', ({ data }) => {
      if (data.type === 'propose-new-time') {
        const { event_id, employer_id, candidate_id } = data.payload;
        const currentUser = document.querySelector('#my-user');
        document.querySelector('#calendar-iframe').src = `${currentUser.value}&candidate=${candidate_id}&propose_new_time=${event_id}`;
        document.querySelectorAll('.user-input').forEach((item) => {
          if (item.id === candidate_id) {
            item.click();
          }
        });
      }
    });
  }
}
